import { IDechargement } from './../../../interfaces/models';
import { Injectable } from '@angular/core';
import { DataService } from 'src/app/services/http/data.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DechargementService extends DataService {

  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  create(dechargement: any) {
    return this.post(dechargement, '?ctrl=dechargement&action=creer');
  }
  supprimer(id: any) {
    return this.delete(id, '?ctrl=dechargement&action=supprimer');
  }

  updateDechargement(dechargement: IDechargement) {
    return this.update(dechargement, '?ctrl=dechargement&action=modifier');
  }

  rdd(numero: any) {
    return this.post(numero, '?ctrl=dechargement&action=rdd');
  }
}
